import "@fullcalendar/common/main.css";
import "@fullcalendar/timeline/main.css";
import "@fullcalendar/resource-timeline/main.css";
import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import { getAvailableBeds, getHousings } from "../../../api/housing";
import { usePagination } from "../../../hooks/usePagination";
import ResultHandler from "../../../components/ResultHandler";
import moment from "moment";
import "./housingTimeline.css";
import { useHistory } from "react-router-dom";

const HousingTimeline = () => {
  const navigate = useHistory();

  // Housings
  const [housings, setHousings] = useState(null);
  const { response, loading, error } = usePagination(getHousings, {
    perPage: 50,
    status: 1,
  });

  useEffect(() => {
    if (response.data) {
      const housingsData = response.data.housings?.map((h, idx) => {
        return {
          id: h.id,
          title: `${h.street_name} ${h.number} ${h.city}`,
          order: idx,
        };
      });
      setHousings(housingsData);
    }
  }, [response]);

  // Beds
  const [beds, setBeds] = useState(null);
  const [startEndDates, setStartEndDates] = useState({});
  const {
    response: bedsResponse,
    setPayload,
    loading: bedsLoading,
    error: bedsError,
  } = usePagination(getAvailableBeds);

  useEffect(() => {
    if (bedsResponse.data) {
      const bedsData = bedsResponse.data.beds?.map((item, idx) => {
        return {
          id: idx + 1,
          resourceId: item.housing_id,
          title: item.available,
          start: moment(item.date).format("YYYY-MM-DD"),
          end: moment(item.date).format("YYYY-MM-DD"),
        };
      });
      setBeds(bedsData);
    }
  }, [bedsResponse]);

  useEffect(() => {
    setPayload(startEndDates);
  }, [startEndDates]);

  const handleDatesSet = (arg) => {
    const start = moment(arg.start).format("YYYY-MM-DD");
    const end = moment(arg.end).format("YYYY-MM-DD");
    setStartEndDates({ start, end });
  };

  const handleEventDidMount = (info) => {
    info.el.style.borderRadius = "5px";
    info.el.style.textAlign = "center";
    info.el.style.margin = "2px";
    info.el.style.fontSize = "13px";
    info.el.style.zIndex = "-5";

    if (info.event.title === "0") {
      info.el.style.backgroundColor = "#ff5b5b";
      info.el.style.borderColor = "#ff5b5b";
    } else {
      info.el.style.backgroundColor = "#4bcd4b";
      info.el.style.borderColor = "#4bcd4b";
    }
  };

  const handleDateClick = (arg) => {
    const houseId = arg.resource.id;
    const clickedDate = moment(arg.start).format("YYYY-MM-DD");
    const isDayFilled = arg.jsEvent.target.classList.contains(
      "fc-timeline-event-harness"
    );

    if (isDayFilled) {
      sessionStorage.setItem("clickedDate", clickedDate);
      navigate.push(`/rooms/${houseId}`, { timeline: true });
    }
  };

  return (
    <div className="mb-5 p-3 shadow-sm rounded bg-white">
      <h4 className="text-center">Housing Available Rooms</h4>

      <ResultHandler loading={loading} error={error} />

      {!loading && housings && (
        <>
          <ResultHandler loading={bedsLoading} error={bedsError} />

          <FullCalendar
            plugins={[resourceTimelinePlugin, interactionPlugin]}
            initialView="resourceTimelineMonth"
            resources={housings}
            events={beds}
            resourceAreaHeaderContent="Housing Address"
            datesSet={handleDatesSet}
            eventDidMount={handleEventDidMount}
            // dateClick={handleDateClick}
            selectable
            select={handleDateClick}
            resourceOrder="order"
            height={450}
            resourceAreaWidth={160}
            schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
          />
        </>
      )}
    </div>
  );
};

export default HousingTimeline;
